export default __webpack_public_path__ + "static/media/oUSDT.fc0e22e9.svg";